import React, { useEffect, useRef, useState } from 'react'
import { Box, Typography, Divider, Button, Dialog, DialogContent, IconButton, FormControl } from '@mui/material'
import { AltRoute, CancelOutlined } from '@mui/icons-material'
import { ApiGetAgreement, ApiPostSignature } from '../../apiService/Core/Apicall.tsx'
import Loading from '../Loader/Loading.tsx'
import { useSelector } from 'react-redux'
import { ReactSketchCanvas, ReactSketchCanvasRef } from 'react-sketch-canvas';
import html2pdf from 'html2pdf.js';
import { toast, ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import store from '../../Redux/Store.tsx'
import { hideLoading, showLoading } from '../../Redux/loadingSlice.tsx'
// import alert from '../../assets/Project_Images/alert.png'
import SignatureCanvas from 'react-signature-canvas';
import trimCanvas from 'trim-canvas'



function Agreement() {
    const [condition, setcondition] = useState<any>()
    const [openSignature, setopenSignature] = useState<boolean>(false)
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [Signature, setSignature] = useState<any>('')
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const loading = useSelector((state: any) => state.loader.isLoading);
    const pdfRef = useRef<HTMLDivElement>(null);
    const canvasRef = useRef<SignatureCanvas>(null);
    const [timestamp, setTimestamp] = useState(Date.now());
    const navigate = useNavigate()
    const isMigratedShopper = localStorage.getItem('i-x-s')
    const isMigratedShopperUpdateDetails = localStorage.getItem('i-x-s-u')


    useEffect(() => {
        const getagreement = async () => {

            try {
                const res = await ApiGetAgreement()
                setcondition(res)
            } catch (error) {
                const message =
                    error?.response?.data?.message || // API error message
                    error?.message ||                 // JS error message
                    String(error);
                toast.error(message)
            }
        }
        getagreement()
    }, [])


    const handleDownloadPdf = () => {
        if (pdfRef.current) {
            const opt = {
                margin: 0.2,
                filename: 'shopper-terms.pdf',
                image: {
                    type: 'jpeg',
                    quality: 0.4 
                },
                html2canvas: {
                    scale: 0.9,
                    useCORS: true
                },
                jsPDF: {
                    unit: 'in',
                    format: 'a4',
                    orientation: 'portrait'
                }
            };

            html2pdf()
                .from(pdfRef.current)
                .set(opt)
                .outputPdf('blob')
                .then(async (pdfBlob: Blob) => {

                    // Convert blob to File
                    const pdfFile = new File([pdfBlob], 'shopper-terms.pdf', { type: 'application/pdf' });

                    const formData = new FormData();
                    formData.append('file', pdfFile);
                    formData.append('userId', userData.userId); // if userId is number, it's okay

                    // Just for debug
                    for (const pair of formData.entries()) {
                        // console.log(`${pair[0]}:`, pair[1]);
                    }

                    // Now call your API with FormData
                    const res = await ApiPostSignature(formData);
                    toast.success(res.message);
                    store.dispatch(hideLoading())
                    if (isMigratedShopper && isMigratedShopperUpdateDetails === "false") {
                        navigate('/dashboard/myprofile')
                    }
                    else if (userData.isShopperAllDocumentSubmitted) {
                        localStorage.removeItem('ng')
                        navigate('/dashboard/dashboard')
                        // navigate('/terms')
                    }
                    else if (userData.userStatus.userStatus === 'approve') {
                        localStorage.removeItem('ng')
                        navigate('/applicationform2')
                    }
                    else {
                        localStorage.setItem('isPopup', 'true')
                        localStorage.removeItem('ng')
                        navigate('/applicationform')
                    }
                })
        };
    }



    const handleClear = () => {
        canvasRef.current?.clearCanvas();
    };

    const handleSave = async () => {
        store.dispatch(showLoading())
        try {
            if (!canvasRef.current) { store.dispatch(hideLoading()); return };

            if (canvasRef.current.isEmpty()) {

                toast.error('Please provide a signature before saving.');
                store.dispatch(showLoading())
                return;
            }
            const dataUrl = await canvasRef.current.toDataURL("image/png");
            // console.log("data URL", dataUrl)
            setSignature(dataUrl)
            setopenSignature(false)
            setTimeout(() => {
                handleDownloadPdf()
            }, 1000);

        } catch (err) {
            console.error("Failed to export signature:", err);
        }
        finally{
            store.dispatch(hideLoading())
        }


    };


    return (
        <Box>
            <ToastContainer />
            <Box padding='20px' className='w-100 custom-bg d-flex align-items-center justify-content-between' height='72px'>
                <Typography className='text-white fs-4 p-0 m-0'>Terms & Conditions</Typography>
                <CancelOutlined className='fs-4 text-white' />
            </Box>
            <Box padding='20px'>
                <div ref={pdfRef}>
                    <Box className='terms'>
                        <Typography fontSize='14px' className='mb-1'>Hi <strong>{userData?.firstName} {userData.lastName ?? localStorage.getItem('FirstName')}</strong>, please read and accept terms of shopper agreement below.</Typography>
                        <div dangerouslySetInnerHTML={{ __html: condition }} />
                    </Box>
                    {Signature.length > 0 &&
                        (<Box className='m-0 p-0' width='fit-content'>
                            <Box component={'img'} maxWidth='100px' height='50px' src={Signature} />
                            <Typography className='text-center'>{new Date(timestamp).toLocaleString()}</Typography>
                        </Box>)}
                    {Signature.length <= 0 && (
                        <FormControl>
                            <SignatureCanvas
                                penColor="black"
                                canvasProps={{
                                    width: 400,
                                    height: 200,
                                    className: 'sigCanvas'
                                }}
                                ref={canvasRef}
                            />
                        </FormControl>)}
                </div>
            </Box>
            <Box padding='20px'>
                <Divider orientation='horizontal' sx={{ borderColor: '#00000033', border: '1px solid #00000033' }} />
                <Box className='d-flex flex-column flex-md-row justify-content-between'>
                    <Button variant='outlined' className='button-primary-outlined my-3 py-2 px-70' onClick={() => { setOpenDialog(true) }}>Disagree</Button>
                    {/* <Button className='button-primary my-3 py-2 px-70' onClick={() => { setopenSignature(true) }}>Agree</Button> */}
                    <Button className='button-primary my-3 py-2 px-70' onClick={() => { handleSave() }}>Agree</Button>
                </Box>

            </Box>
            <Dialog open={openSignature} className='mx-auto' sx={{ width: 'fit-content' }} onClose={() => setopenSignature(false)}>
                <DialogContent sx={{ width: 'fit-content !important' }}>
                    <div style={{ maxWidth: '600px' }}>
                        <h3 className='text-center text-main mb-2'>Draw your Signature here</h3>
                        <SignatureCanvas
                            penColor="black"
                            canvasProps={{
                                width: 400,
                                height: 100,
                                className: 'sigCanvas'
                            }}
                            ref={canvasRef}
                        />
                        <div style={{ marginTop: '10px' }}>
                            <Box className='d-flex flex-column flex-md-row justify-content-center' gap={2}>
                                <Button variant='outlined' className='button-primary-outlined my-3 py-2 px-3' onClick={handleClear}>Clear</Button>
                                <Button className='button-primary my-3 py-2 px-3' onClick={handleSave}>Upload Signature</Button>
                            </Box>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
            <Dialog open={openDialog} className='mx-auto' sx={{ maxWidth: '500px' }}>
                <DialogContent>
                    <Box className='d-flex justify-content-end'>
                        <IconButton onClick={() => { setOpenDialog(false) }}><CancelOutlined></CancelOutlined></IconButton>
                    </Box>
                    <Box className='d-flex flex-column align-items-center' gap={1}>
                        <Box component='img' className='col-5 mx-auto' src={alert}></Box>
                        <Typography fontWeight='bold' className='text-center' variant='h6'>
                            Are You Sure ?
                        </Typography>
                        <Typography className='text-center col-12'>
                            Your application will be rejected if you do not agree to our terms and conditions. If you decline and change your mind, you will need to reapply.
                        </Typography>
                        <Box className='d-flex justify-content-center' gap={1}>
                            <Button className='button-primary px-5 py-2 mt-3' onClick={() => { navigate('/login'); localStorage.clear() }}>Log Out</Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
            {loading && <Loading />}
        </Box>

    )
}

export default Agreement